<template>
    <div class="backgroung_new">
        <inputs></inputs>
    </div>
</template>
<script>
import Inputs from "./components/MainPage";

export default {
  name: "components",
  components: {
    Inputs
  }
};
</script>
<style>
    .backgroung_new {
        background-image: url("../../public/img/theme/bgnew2.png");
        z-index: 1000;
    }
</style>
